import React from 'react';
import PropTypes from 'prop-types';
import {Form} from '@evag/ec-react';

import Layout from '../components/Layout';
import SEO from '../components/SEO';

import CustomHero from 'src/components/CustomHero';
import Peticao from 'src/components/forms/parts/Peticao';
import OAB from 'src/components/forms/parts/OAB';
import Feedback from '../components/forms/parts/Feedback';

import styles from './cassacao.module.scss';
import a from '../components/Article.module.scss';

const title = "MANA, VEM CONHECER O PSOL!"
const channelId = "fb2d3c6b-df1c-406b-a2a5-78279f86dccf"

export default function render({data, location}) {
  return (
    <Layout solidHeader={true}>
      <SEO
        title={title}
        description="Faça já sua inscrição e venha debater a luta feminista com a gente!"
        ogimage={{
          src:
            'https://cdn.samiabomfim.com.br/wp-content/uploads/2021/04/formulario.jpg',
          width: '1200',
          height: '600',
        }}
      />

      <CustomHero
        image={{
          alt: title,
          src:
            'https://cms.samiabomfim.com.br/wp-content/uploads/2021/04/fundo-formulario.jpg',
        }}
        overClassName={styles.over}
      >
        <img
          style={{display: 'block', margin: 'auto'}}
          src="https://cms.samiabomfim.com.br/wp-content/uploads/2021/04/texto-formulario.png"
        />
      </CustomHero>

      <div className={styles.form}>
        <div className={a.wrap}>
          <h1>{title}</h1>
          <br/>
        <p><strong>
        Dia: 09/04
        <br/>
        
        Horário: 18h30
        </strong>
        
</p>
<br/>
<p>
O Juntas é um movimento construído por muita mulheres do PSOL, porém não se restringe apenas as filiadas do partido Apesar de sermos mais amplas do que o PSOL, este é o partido que consideramos nosso aliado prioritário, e que melhor representa as pautas feministas. Também através do PSOL que o Juntas elegeu suas candidaturas para ocupar a politica institucional. Foi assim com as deputadas federais Sâmia Bomfim, Fernanda Melchionna, Vivi Reis e Monica Seixas, co-deputada estadual em SP e Mariana Conti, vereadora na cidade de Campinas (SP).  Por isso convidamos a todes para somar sua fúria contra Bolsonaro, contra o machismo e todo tipo de opressão com o Juntas e o PSOL.
              </p>
              <br/>
        <p>
          <strong>As feministas também tomam partido! é pela vida das mulheres, pela defesa dos direitos e da construção coletiva de uma nova sociedade.</strong>
        
              </p>

          <Form
            forms={[
              {
                ...Peticao,
                channelId,
                showFiliado: true,
                btnText: 'Inscrever',
              },
              {
                ...Feedback,
                url: location.href,
                text:
                  'Muito obrigada! Agora ajude a espalhar compartilhando nas redes sociais.',
              },
            ]}
          />
        </div>
      </div>
    </Layout>
  );
}

render.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};
